import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class DemoStoryblokService extends StoryblokService {
  constructor() {
    super();
    this.baseURL += "/demos";
  }
  async getHeaderImage() {
    try {
      return this.getSingleImage("".concat(this.baseURL, "/header/demo_header_logo"));
    } catch (error) {
      console.warn(error);
      return "";
    }
  }
  async getFooterImage() {
    try {
      return this.getSingleImage("".concat(this.baseURL, "/footer/demo_footer_logo"));
    } catch (error) {
      console.warn(error);
      return "";
    }
  }
  async getPoweredByImage() {
    try {
      return this.getSingleImage("".concat(this.baseURL, "/ui/chip"));
    } catch (error) {
      console.warn(error);
      return "";
    }
  }
}
const demoStoryblokService = new DemoStoryblokService();
export default demoStoryblokService;